import React from 'react';
import './WhyEmbrace.css';

const WhyEmbrace = () => {
    return (
        <section className="why-embrace" id="about-us">
            <div className="container why-embrace-container">

                {/* Left Side: Text and Core Features */}
                <div className="why-embrace-content">
                    <span className="section-subtitle">Why Embrace?</span>
                    <h2 className="section-title">Rooted in Experience, Driven by Results.</h2>
                    <p className="section-desc">
                        We prioritize your needs with personalized treatments, maintaining the highest
                        standards of care. Our focus is to help you look and feel your best with trusted expert care.
                    </p>

                    <div className="features-list">
                        <div className="feature-item">
                            <div className="feature-icon-wrap">
                                <svg viewBox="0 0 24 24" className="feature-svg-icon" fill="none" stroke="currentColor" strokeWidth="1.5">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 6a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0ZM4.501 20.118a7.5 7.5 0 0 1 14.998 0A17.933 17.933 0 0 1 12 21.75c-2.676 0-5.216-.584-7.499-1.632Z" />
                                </svg>
                            </div>
                            <div className="feature-text">
                                <h3>Personalized Care Plans</h3>
                                <p>We understand your unique goals and create customized treatment plans for the best results.</p>
                            </div>
                        </div>

                        <div className="feature-item">
                            <div className="feature-icon-wrap">
                                <svg viewBox="0 0 24 24" className="feature-svg-icon" fill="none" stroke="currentColor" strokeWidth="1.5">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M12 6v12m-3-2.818l.265.113a3.374 3.374 0 0 0 4.97-3.077c0-2.053-1.666-3.374-4.97-4.114m0-3.077a3.374 3.374 0 0 0-4.97 3.077c0 2.053 1.666 3.374 4.97 4.114M12 3v18" />
                                </svg>
                            </div>
                            <div className="feature-text">
                                <h3>Transparent Pricing</h3>
                                <p>No hidden costs—our pricing is clear and straightforward, so you know what to expect.</p>
                            </div>
                        </div>

                        <div className="feature-item">
                            <div className="feature-icon-wrap">
                                <svg viewBox="0 0 24 24" className="feature-svg-icon" fill="none" stroke="currentColor" strokeWidth="1.5">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M11.42 15.17 17.25 21A1.752 1.752 0 0 0 20 18.58l-5.83-5.83m.94-2.26c1.233-1.233 1.233-3.23 0-4.463a3.156 3.156 0 0 0-4.463 0l-4.463 4.463a3.156 3.156 0 0 0 0 4.463c1.233 1.233 3.23 1.233 4.463 0l1.115-1.115M12 9h.008v.008H12V9Z" />
                                </svg>
                            </div>
                            <div className="feature-text">
                                <h3>State of the art equipment</h3>
                                <p>We use cutting-edge technology to ensure safe, effective, and long-lasting results.</p>
                            </div>
                        </div>

                        <div className="feature-item">
                            <div className="feature-icon-wrap">
                                <svg viewBox="0 0 24 24" className="feature-svg-icon" fill="none" stroke="currentColor" strokeWidth="1.5">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75 11.25 15 15 9.75M21 12c0 1.268-.63 2.39-1.593 3.068a3.745 3.745 0 0 1-1.043 3.296 3.745 3.745 0 0 1-3.296 1.043A3.745 3.745 0 0 1 12 21" />
                                </svg>
                            </div>
                            <div className="feature-text">
                                <h3>Safe and Comfortable Treatments</h3>
                                <p>Your safety and comfort are our priority. Our highly trained professionals ensure a smooth, relaxing experience.</p>
                            </div>
                        </div>
                    </div>

                    {/* Founder Profile Row */}


                </div>
            </div>
        </section>
    );
};

export default WhyEmbrace;
